module.exports = __webpack_public_path__ + "img/workaholic.f3c9028e.svg";